import { useBoolean } from '@insta-club/hooks';
import { Guides, Post } from '@insta-club/models';
import { Checkbox, CustomCollapse, GuideDialog, GuidesButton } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import { useState } from 'react';
import { CoffeeIcon, VideoCircle } from 'src/libs/components/icons';
import PostingProgram from './program';

interface Props {
    post?: Post;
    hasChatBot: boolean;
    programID: number;
    dayNumber: number;
    canPerformTask: boolean;
}

const PostingTask: React.FC<Props> = ({ post, programID, dayNumber, hasChatBot, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    const disabled = !post;
    const description = disabled
        ? 'در این روز پست برای انتشار نداریم، پس وقت آزاد خودتو به بهترین شکل پر کن و از لحظاتت لذت ببر !'
        : post?.is_done
          ? 'تکمیل شده'
          : `${post?.post_type?.subject}`;
    // const status = post?.is_done ? 'done' : 'progress';
    const isDone = post?.is_done;

    return (
        <>
            <section className='space-y-3.5'>
                <CustomCollapse
                    disabledToggle={!post}
                    contentBgColor='bg-gray-50'
                    titleClassName='w-full'
                    borderClassName='border-transparent'
                    headerBgColor='bg-gray-100'
                    // headerBgColor={cn({
                    //     'bg-gray-100': !isDone,
                    //     'bg-success-50': isDone || !post
                    // })}
                    title={
                        <div className='flex items-center justify-between pl-3'>
                            <div className='text-primary-900 flex w-full flex-col items-start space-y-1 text-base font-bold'>
                                <div className='flex items-start space-x-1'>
                                    <span className='mt-0.5'>برنامه</span>
                                    <span
                                        className={cn('mt-0.5', {
                                            'text-success-500': isDone
                                        })}
                                    >
                                        پست گذاری
                                    </span>
                                    {!post && <CoffeeIcon width={20} className='text-success-500 mb-0.5' />}
                                    {!!isDone && <Checkbox checked color='green' readOnly disabled />}
                                </div>
                                <p className='text-right text-sm font-normal text-gray-600'>{description}</p>
                            </div>
                        </div>
                    }
                >
                    {post ? (
                        <>
                            <div className='mb-2 space-y-1.5'>
                                <p className='text-right text-sm font-normal text-gray-600'>
                                    این برنامه پیشنهادی با توجه به بهترین زمان پیک حضور مخاطبین در اینستاگرام است ، شما
                                    میتوانید با توجه به شرایط پیجتون زمان ها رو تغییر بدید.
                                </p>
                                <div className='flex justify-end'>
                                    <GuidesButton
                                        guideKey='program_post'
                                        onClick={openGuide}
                                        noModal
                                        trigger={
                                            <button
                                                className='text-primary-700 font-500 flex cursor-pointer items-center space-x-1 rounded-full text-sm'
                                                aria-label='ویدیو راهنما'
                                            >
                                                <VideoCircle width={20} />
                                                {/* <span>ویدیو راهنما</span> */}
                                            </button>
                                        }
                                    />
                                </div>
                            </div>

                            <PostingProgram
                                post={post}
                                // onGuide={openGuide}
                                programID={programID}
                                dayNumber={dayNumber}
                                hasChatBot={hasChatBot}
                                canPerformTask={canPerformTask}
                            />
                        </>
                    ) : (
                        <></>
                    )}
                </CustomCollapse>
            </section>
            {/* <ProgramCategory
                title={t('program', t('posting'))}
                description={post?.is_done ? 'تکمیل شده' : `${post?.post_type?.subject}`}
                status={post?.is_done ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!post}
            /> */}
            {/* {post ? (
                <BottomSheet title={`${t('program')} ${t('posting')}`} open={sheet.value} onClose={sheet.onFalse}>
                    <PostingProgram
                        post={post}
                        onGuide={openGuide}
                        programID={programID}
                        dayNumber={dayNumber}
                        hasChatBot={hasChatBot}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null} */}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default PostingTask;

